import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Antd from "ant-design-vue";
import "./permission"; // permission control
import ProLayout, { PageHeaderWrapper } from "@ant-design-vue/pro-layout";

import "ant-design-vue/dist/antd.css";
import "./global.less"; // global style
import "./core/lazy_use"; // use lazy load components

Vue.use(Antd);
Vue.config.productionTip = false;
Vue.component("pro-layout", ProLayout);
Vue.component("page-container", PageHeaderWrapper);
Vue.component("page-header-wrapper", PageHeaderWrapper);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
